import React from "react";
import vhpLogo from "../../assets/VHP-Logo.png";

function Partners() {
  return (
    <div className="flex justify-center items-center flex-col mt-10 mb-5">
      <h1 className="text-transparent tracking-tight letter-spacing:-0.05em text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] pb-1 pt-32 bg-clip-text mb-1 font-bold bg-gradient-to-r from-[#8926B6] to-[#EABCFF]">
        Our Partner
      </h1>
      <img
        src={vhpLogo}
        alt=""
        className="pb-64 mt-10 w-7/12 md:w-4/12 lg:w-3/12 2xl:w-2/12"
      />
    </div>
  );
}

export default Partners;
